<div>
    <i class="fa-fw"
       [ngClass]="icon"
       aria-hidden="true"></i>&nbsp;
    <span class="label"
          *ngIf="keyTrad">{{ keyTrad | translate }}&nbsp;
    </span>
    <span class="value">
        <ng-content></ng-content>
    </span>
</div>
